// @flow
/**
 * User: Mike Chung
 * Date: 16/1/2018
 * Time: 10:06 PM
 */

import {combineReducers} from "redux";
import {reducer as formReducer} from "redux-form";
import type {EBadgeQueryState} from "./EBadgeQueryReducer";
import EBadgeQueryReducer from "./EBadgeQueryReducer";
import type {EBadgeActionState} from "./EBadgeActionReducer";
import EBadgeActionReducer from "./EBadgeActionReducer";
import type {MenuState} from "./MenuReducer";
import MenuReducer from "./MenuReducer";
import type {BootstrapState} from "./BootstrapReducer";
import BootstrapReducer from "./BootstrapReducer";
import type {FairConfigState} from "./FairConfigReducer";
import FairConfigReducer from "./FairConfigReducer";
import type {CountryState} from "./CountryReducer";
import CountryReducer from "./CountryReducer";
import type {SsoUserQueryState} from "./SsoUserQueryReducer";
import SsoUserQueryReducer from "./SsoUserQueryReducer";
import type {ModalState} from "./ModalReducer";
import ModalReducer from "./ModalReducer";
import type {SsoUserActionState} from "./SsoUserActionReducer";
import SsoUserActionReducer from "./SsoUserActionReducer";
import type {ProfileState} from "./ProfileReducer";
import ProfileReducer from "./ProfileReducer";
import JwtReducer from "./JwtReducer";
import type {JwtState} from "./JwtReducer";
import PhotoEBadgeReducer from "./PhotoEBadgeReducer";
import type {PhotoEBadgeQueryState} from "./PhotoEBadgeReducer";
import PhotoEBadgeActionReducer from "./PhotoEBadgeActionReducer";
import type {PhotoEBadgeActionState} from "./PhotoEBadgeActionReducer";

export default combineReducers({
    eBadgeQuery: EBadgeQueryReducer,
    photoEBadgeQuery: PhotoEBadgeReducer,
    form: formReducer,
    eBadgeAction: EBadgeActionReducer,
    photoEBadgeAction: PhotoEBadgeActionReducer,
    menu: MenuReducer,
    bootstrap: BootstrapReducer,
    fairConfigs: FairConfigReducer,
    countries: CountryReducer,
    ssoUserQuery: SsoUserQueryReducer,
    ssoUserAction: SsoUserActionReducer,
    modal: ModalReducer,
    profile: ProfileReducer,
    loginUser: JwtReducer
});

export type StoreState = {
    eBadgeQuery: EBadgeQueryState,
    photoEBadgeQuery: PhotoEBadgeQueryState,
    eBadgeAction: EBadgeActionState,
    photoEBadgeAction: PhotoEBadgeActionState,
    menu: MenuState,
    form: any,
    bootstrap: BootstrapState,
    fairConfigs: FairConfigState,
    countries: CountryState,
    ssoUserQuery: SsoUserQueryState,
    modal: ModalState,
    ssoUserAction: SsoUserActionState,
    profile: ?ProfileState,
    loginUser: JwtState
};


// WEBPACK FOOTER //
// ./src/reducers/combinedReducers.js